module.exports = __webpack_public_path__ + "static/img/example5.2f0879f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/example5.jpg
// module id = uCcD
// module chunks = 1